import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=3130fed0&scoped=true&"
import script from "./Questions.vue?vue&type=script&lang=js&"
export * from "./Questions.vue?vue&type=script&lang=js&"
import style0 from "./Questions.vue?vue&type=style&index=0&id=3130fed0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3130fed0",
  null
  
)

export default component.exports